import { ISbStoryData } from 'gatsby-source-storyblok';
import callStoryblokApi from './call-storyblok-api';
import { environment } from '../../environment';
import { getArticleBlokFromPageStory } from '../helpers/get-article-blok-from-page-story';
import { IArticle } from '../components';

interface IArticlesQueryArguments {
  blogSlug: string;
  limit: number;
  page?: number;
  categories?: string[];
}

export const getArticles = async ({
  blogSlug,
  limit,
  page = 1,
  categories,
}: IArticlesQueryArguments): Promise<IArticle[]> => {
  const queryObject: Record<string, any> = {
    sort_by: 'created_at:desc',
    with_tag: environment.storyblokArticlePageTag,
    by_slugs: `${blogSlug}/*`,
    per_page: limit,
    page,
  };

  if (categories?.length) {
    queryObject['filter_query[article_category][in]'] = categories?.join(',');
  }

  const response = await callStoryblokApi<{ stories: ISbStoryData[] }>('stories', queryObject);

  const articles = response.stories.map(getArticleBlokFromPageStory);

  return articles;
};
